export default __webpack_public_path__ + "static/media/rnb-et.0a0c82f4.webp";